goog.provide("shadow.js.shim.module$src$svg$chevron$chevron_down_svg$default");
shadow.js.shim.module$src$svg$chevron$chevron_down_svg$default = shadow.js.shim.module$src$svg$chevron$chevron_down_svg.default;
